
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;

@Component({

  selector: 'app-service-applicant4school',

  templateUrl: './service-applicant4school.component.html',

  styleUrls: ['./service-applicant4school.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ServiceApplicant4schoolComponent implements OnInit {

  searchT_School = '';

  list_Schools: any = [];

  filteredSchools = [];

  list_Status = [];

  list_Applicant: any = [];

  list_ApplicantSearch = [];

  list_CarType: any[] = [];

  tiServiceRequestStatus: string | number = -1;

  iMobileDomain: string | number = -1;

  isLoading: boolean = false;

  studentData: any;

  editMode: boolean = false;

  map: any;

  source: any;

  vector: any;

  layers: any = [];

  selectedIndex!: number;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService,

    private _otherService: OtherService

  ) { }

  ngOnInit(): void {

    this.getSchools();

    this.getService_Status();

  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = -1;

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Applicant = this.list_ApplicantSearch.filter((el: any) => {

        return el.strMobileDomain_strComment.includes(search) || el.strPassenger_FullName.includes(search)

      })
    }

    else if (search == '') this.list_Applicant = this.list_ApplicantSearch
  }

  selectedSchool(item: any) {

    this.searchT_School = item.strComment;

    this.filteredSchools = [];

    this.iMobileDomain = item.iMobileDomain;

  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

  }

  async getService_Status() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`ServiceRequestStatus_List`, model)).data.toString());

    this.list_Status = res;

  }

  async searchApplicant_Service() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: this.iMobileDomain,

      tiServiceRequestStatus: this.tiServiceRequestStatus

    }


    let res = JSON.parse((await axios.post(`IWantService_List`, model)).data.toString());

    this.list_Applicant = res;

    this.list_ApplicantSearch = res;

    this.isLoading = false;

  }

  async showDetail(item: any, mode: boolean, index?: number) {

    if (index) this.selectedIndex = index;

    if (item.tiServiceRequestStatus > 3 && mode == true) return this.Notification.showError('امکان ویرایش وجود ندارد')

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_Passenger_Info`, model)).data.toString())[0];

    res.strAvatar = '';

    this.studentData = { ...item, ...res };

    this.editMode = mode;

    $('#detailModal').modal('show');


  }

  async editApplicant() {

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this.studentData.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

            this.studentData.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

            let res = JSON.parse((await axios.post(`IWantService_Edit`, this.studentData)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('با موفقیت ویرایش شد');

              $('#detailModal').modal('hide');

              this.list_Applicant[this.selectedIndex] = res[0]


            }
          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async calcDistance(iMobileDomain: any) {

    const selectedSchool = this.list_Schools.find((a: any) => {

      return a.iMobileDomain == iMobileDomain

    })

    const school = selectedSchool;

    if ((school?.length != 1 && school?.length != undefined) || (school?.length != undefined && school?.length != 1)) return this.Notification.showError('مدرسه ایی انتخاب نشده است !');

    else {

      this._otherService.Showspinner()

      var model = {

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        fSLat: this.studentData.fOrigiLat,

        fSLon: this.studentData.fOriginLon,

        fDLat: school.length == undefined ? school.fLat : school[0].fLat,

        fDLon: school.length == undefined ? school.fLon : school[0].fLon,

      }

      let res = JSON.parse((await axios.post(`CalDistanceBetween2Point`, model)).data.toString());

      this.studentData.fDistance = `${res}`;

      var model_2 = this._otherService.stringNumberToNumber({

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        iPassenger: this.studentData.iPassenger,

        fDistance: res,

      })

      let res_2 = JSON.parse((await axios.post(`School_Passenger_UpdateDistance`, model_2)).data.toString());

      if (res_2.iResult == 0) return this.Notification.showError(res_2.strError)

      this._otherService.nonespinner();


    }

  }

  async costCalculate() {

    this._otherService.Showspinner()

    let resp = await axios.post(`GetMobileType`);

    resp.data.unshift({ tiMobileType: -1, strComment: 'انتخاب کنید' })

    this.list_CarType = resp.data;

    this._otherService.nonespinner();

    var options = '';

    this.list_CarType.forEach(function (item) {

      options += '<option value="' + item.tiMobileType + '">' + item.strComment + '</option>';

    });

    $.confirm({

      title: `نوع خودرو را مشخص کنید`,

      content: `<select class="form-control" id="mySelect">${options}</select>`,

      type: 'blue',

      buttons: {

        ok: {

          text: "محاسبه هزینه ",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var selectedValue = $('#mySelect').val();

            if (selectedValue == '-1') return this.Notification.showError('لطفا نوع خودرو را مشخص کنید !!');

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              iPassenger: this.studentData.iPassenger,

              tiMobileType: selectedValue,

            }

            this._otherService.Showspinner()

            let res = JSON.parse((await axios.post(`School_ServiceFee_Cal`, model)).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            res = !res.length ? res : res[0]

            var message = " کرایه خالص راننده : " + `<span class='text-success fw-bold'> ${res.iBaseCost?.toLocaleString()} ریال </span>` + "<br/>" +

              " تامین اجتماعی : " + `<span class='text-success fw-bold'> ${res.iInsurance?.toLocaleString()} ریال </span>` + "<br/>" +

              " آموزش و پرورش : " + `<span class='text-success fw-bold'> ${res.iEducation?.toLocaleString()} ریال </span>` + "<br/>" +

              " شهرداری : " + `<span class='text-success fw-bold'> ${res.iMunc?.toLocaleString()} ریال </span>` + "<br/>" +

              " شرکت : " + `<span class='text-success fw-bold'> ${res.iCompany?.toLocaleString()} ریال </span>` + "<br/>" +

              " پرداختی اولیا : " + `<span class='text-success fw-bold'> ${res.iFinalCost?.toLocaleString()} ریال </span>` + "<br/><br/>"


            $.confirm({

              title: `تعرفه سرویس به شرح زیر می باشد : `,

              content: `${message}`,

              type: 'blue',

              buttons: {

                cancel: {

                  text: "بستن",

                  btnClass: 'btn-secondary px-5',

                }

              }

            });

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  showOnMap() {

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });


      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([this.studentData.fOriginLon, this.studentData.fOrigiLat]),

          zoom: 13,

        }),

      });

    }, 500);

  }

  getStr_Status(tiServiceRequestStatus: number) {

    const status: any = this.list_Status.find((a: any) => {

      return a.tiServiceRequestStatus == tiServiceRequestStatus;

    });

    return status ? status.strComment : '';
  }

  goBack() {

    this.router.navigate(['/'])

  }

}
